import React, { Component } from 'react'
import { FEATURE_PREDOMINANCE_ID } from '../../constants/constants'
import Tastes from './Tastes'
import Effect from './Effect'

export default class Effects extends Component {
  get predominance() {
    const { product, productFeatures } = this.props

    if (!product || !product.associations) return ''

    const { associations: { product_features } } = product
    if (!product_features) return ''

    const pf = product_features.find(
      ({ id }) => parseInt(id, 10) === FEATURE_PREDOMINANCE_ID
    )
    if (!pf || typeof pf !== 'object') return ''

    // productFeatures podría no estar listo todavía
    const allValues = productFeatures?.values?.all
    if (!allValues) return ''

    const result = allValues[pf.id_feature_value]
    if (!result || typeof result !== 'object') return ''

    return result.value || ''
  }

  render() {
    const { product } = this.props

    // Si el producto aún no ha llegado, evita reventar.
    // Podemos devolver null o un loader.
    if (!product) return null

    // type_witproduct puede venir undefined/string; lo hacemos robusto
    if (Number(product.type_witproduct)) {
      return null
    }

    const effects = {}

    Object.keys(product).forEach((key) => {
      const titleMatch = key.match(/^titulo_efecto_([0-9]{1})/)
      if (titleMatch && titleMatch.length) {
        const [, id] = titleMatch
        const titleValue = product[key]
        if (titleValue && titleValue.length) {
          if (!effects[id]) effects[id] = {}
          effects[id].title = titleValue
        }
      }

      const valueMatch = key.match(/^valor_efecto_([0-9]{1})/)
      if (valueMatch && valueMatch.length) {
        const [, id] = valueMatch
        const val = product[key]
        if (val && val.length) {
          if (!effects[id]) effects[id] = {} // <-- FIX: evitar undefined
          effects[id].value = val
        }
      }
    })

    return (
      <div className='variety-fx active'>
        <div className='variety-fx-data'>
          <p>{this.predominance}</p>

          {Object.values(effects).map((effect, index) => (
            <Effect
              {...effect}
              index={index}
              key={`effect-${index}`}
            />
          ))}
        </div>

        <Tastes {...this.props} />
      </div>
    )
  }
}
